import * as React from "react";
import "./GenericQuestionGroupList.css";
import { HRQuestionGroupWithStatus } from "../models/HR";
import { HRAvailabilityPlaceholderSettings, HRQuestionId, HRQuestionTemplateId, HRAnswerResult } from "../messages";
import { HRQuestionGroupId } from "../messages/ObjectIds";
import { GenericQuestionGroup } from "./GenericQuestionGroup";
import { API } from "../API";
import { HRCertificationPayRates, CertificationSettings, HRCertificationPayRatesWithSupplementals } from "../messages/Agency";

interface GenericQuestionGroupListProps {
    showUnfinishedError: { errors: number, loading: number } | null;
    documentStatus: "LOADING" | "ERROR" | null;
    groups: HRQuestionGroupWithStatus[];
    availabilitySettings: HRAvailabilityPlaceholderSettings | null;
    // TODO give type to newval
    onAnswerChange: (newVal: any, questionId: HRQuestionId, groupId: HRQuestionGroupId) => void;
    onAnswerBlur: (questionId: HRQuestionId, groupId: HRQuestionGroupId) => void;
    onTriggerEvaluateHierarchyStatus: (questionId: HRQuestionId, groupId: HRQuestionGroupId) => void;
    onPayRatesChange: (rates: HRCertificationPayRatesWithSupplementals) => Promise<HRAnswerResult>;
    getCertificationPayRates: () => CertificationSettings;
    onNextButtonClick: () => void;
    api: API;
}

export class GenericQuestionGroupList extends React.Component<GenericQuestionGroupListProps> {
    constructor(props: GenericQuestionGroupListProps) {
        super(props);
    }

    getErrorText(errors: number, loading: number): string {
        let toReturn: string = "";
        if (errors > 0) {
            toReturn = `Missing ${errors} question(s), please complete the form`;
        } else if (loading > 0) {
            toReturn = `${loading} question(s) are loading, please try again`;
        }

        return toReturn;
    }

    shouldShowPDFHeader() {
        return this.props.groups.find(group => {
            return group.questions.find(q =>
                q.question.textId === HRQuestionTemplateId.wrap("PlaceholderIt2014Form") ||
                q.question.textId === HRQuestionTemplateId.wrap("PlaceholderW4Form") ||
                q.question.textId === HRQuestionTemplateId.wrap("PlaceholderI9Form") ||
                q.question.textId === HRQuestionTemplateId.wrap("PlaceholderF102Form") ||
                q.question.textId === HRQuestionTemplateId.wrap("PlaceholderF103Form") ||
                q.question.textId === HRQuestionTemplateId.wrap("PlaceholderW42020Form") ||
                q.question.textId === HRQuestionTemplateId.wrap("WSTEHBPlaceholder")
            ) !== undefined;
        }) !== undefined;
    }

    render() {
        return (
            <div className={"GenericQuestionGroupList__root"} id={"GenericQuestionGroupListRootId"}>
                {this.shouldShowPDFHeader() ? (
                        <div className={"GenericQuestionGroupList__pdfHeader"}>
                            Please see example PDF at the bottom
                        </div>
                    )
                    : null}
                {this.props.groups.map((group, i) => {
                    let showTitle = false;
                    group.questions.forEach(qg => {
                        if (!qg.question.isHidden) {
                            showTitle = true;
                        }
                    });
                    return ( showTitle &&
                        <div key={i} className="GenericQuestionGroupList__item">
                            <h2 className="Globals__marginTopLarge GenericQuestionGroupList__groupTitle">{group.data.title}</h2>
                            {group.data.subtitle !== null ?
                                <h4 className="Globals__marginTopLarge GenericQuestionGroupList__groupTitle">{group.data.subtitle}</h4>
                                :
                                null}
                            <GenericQuestionGroup
                                questions={group.questions}
                                onAnswerChange={(newVal, questionId) => this.props.onAnswerChange(newVal, questionId, group.data.id)}
                                onAnswerBlur={(questionId) => this.props.onAnswerBlur(questionId, group.data.id)}
                                onTriggerEvaluateHierarchyStatus={(questionId) => this.props.onTriggerEvaluateHierarchyStatus(questionId, group.data.id)}
                                onPayRatesChange={(rates) => this.props.onPayRatesChange(rates)}
                                getCertificationPayRates={() => this.props.getCertificationPayRates()}
                                api={this.props.api}
                                availabilitySettings={this.props.availabilitySettings}
                            />
                        </div>
                    );
                })}
                <button
                    className={"btn btn-lg btn-primary GenericQuestionGroupList__nextButton"}
                    onClick={this.props.onNextButtonClick}
                >
                    {this.props.documentStatus === null ? "Confirm and continue" : this.props.documentStatus === "LOADING" ? "Processing..." : "The server returned an ERROR, please try again"}
                </button>

                {this.props.showUnfinishedError !== null ?
                    <div className={"GenericQuestionGroupList__errorContainer"}>
                        <h4 className={"text-danger"}>
                            {this.getErrorText(this.props.showUnfinishedError.errors, this.props.showUnfinishedError.loading)}
                        </h4>
                    </div>
                    :
                    null
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/GenericQuestionGroupList.tsx